import React from 'react';
import PropTypes from 'prop-types';
import NoteBookIcon from '@learningblocks/exp-constants/lib/Images/notebook-icon.svg';
import NoteBookIconHover from '@learningblocks/exp-constants/lib/Images/notebook-icon-hover.svg';
import NoteBookIconCollapse from '@learningblocks/exp-constants/lib/Images/notebook-icon-collapse.svg';
import {Image} from '@learningblocks/exp-components';
import './style.scss';

export class DrawerHandle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
  }
  mouseOver = () => this.setState({hover: true});
  mouseOut = () => this.setState({hover: false});

  handleIcon = () => {
    if (this.props.collapsed) return NoteBookIconCollapse;
    else if (this.state.hover) return NoteBookIconHover;
    else return NoteBookIcon;
  };

  handleIconAlt = () => {
    return 'notebook-icon';
  };

  wrapperClass = () => {
    const classList = [
      'drawer-handle',
      this.props.collapsed ? 'collapsed' : 'expanded',
    ];
    return classList.join(' ');
  };

  onClick = (event) => {
    event.stopPropagation();
    this.props.toggleCollapse(!this.props.collapsed);
  };

  render() {
    return (
      <span
        onClick={this.onClick}
        className={this.wrapperClass()}
        onMouseOver={this.mouseOver}
        onMouseOut={this.mouseOut}>
        <Image src={this.handleIcon()} alt={this.handleIconAlt()} />
      </span>
    );
  }
}

DrawerHandle.propTypes = {
  toggleCollapse: PropTypes.func,
  collapsed: PropTypes.bool.isRequired,
};
